import styled from 'styled-components';
import colors from '../colors';

const SubMenu = styled.ul.attrs(({ label = '' }) => ({
	'aria-label': `${label} submenu`
}))`
	list-style: none;
	margin: 0;
	padding: 0;

	ul {
		display: none;
	}

	ul,
	li {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	a,
	a:visited,
	a:focus,
	a:active,
	span {
		color: ${colors.white} !important;
	}
`;

export const SubMenuListItem = styled.li`
	position: relative;

	
	&:hover {
		background-color: ${colors.black};

		ul {
			display: block;
			position: absolute;
			left: 100%;
			width: auto;
			min-width: 230px;
			top: 0;
			transition: background-color 0.1s ease, color 0.1s ease;
			background-color: ${colors.dgray};
		}

		svg {
			color: ${colors.pink};
		}
	}
}`;

export default SubMenu;
